import type { PromptCategoryConfig } from "./types";

import React from "react";

import {
  AppWindow,
  Briefcase,
  ListOrdered,
  Megaphone,
  SquareStack,
  Tag as TagIcon,
} from "lucide-react";

export const PROMPT_CATEGORIES: PromptCategoryConfig[] = [
  { id: "reference", label: "Start from reference", icon: <SquareStack /> },
  { id: "landing", label: "Landing", icon: <AppWindow /> },
  { id: "product", label: "Product", icon: <TagIcon /> },
  { id: "listicle", label: "Listicle", icon: <ListOrdered /> },
  { id: "advertorial", label: "Advertorial", icon: <Megaphone /> },
  { id: "by-industry", label: "By industry", icon: <Briefcase /> },
];
